interface Payload {
  [key: string]: any;
}

export function installGTM(): void {
  const GTMID = 'GTM-TNCRJ6X';
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  const head = document.head || document.querySelector('head');

  const script = document.createElement('script');
  script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${GTMID}');`;

  head.insertAdjacentElement('beforeend', script);
}

export function pushDataLayer(payload: Payload): void {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
}
